'use client';
import type { ToastContainerProps } from 'react-toastify';

export const classes = {
  app: 'h-dvh w-screen absolute top-0 left-0 overflow-hidden bg-no-repeat bg-cover bg-site-background',
  notFound:
    'size-full text-2xl text-grey-7 place-center bg-site-background dark:text-mauve-2 dark:bg-[#1a1620]',
};

// eslint-disable-next-line no-restricted-syntax
export const toastContainerProps: ToastContainerProps = {
  hideProgressBar: true,
  closeOnClick: true,
  newestOnTop: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  rtl: false,
  draggable: false,
  theme: 'light',
  position: 'bottom-right',
  autoClose: 3000,
  toastStyle: {
    borderRadius: '1rem',
    padding: '0.6rem',
    paddingRight: '0.8rem',
  },
};
